import { Injectable } from '@angular/core';
import { RestApiService } from '../../shared/services/rest-api.service';
import { Observable, of, BehaviorSubject, Subject } from 'rxjs';
import * as moment from 'moment';
import { StorageService } from './../../shared/services/storage.service';
import { AppSettings } from './../../shared/app.settings';
import { TranslateService } from '@ngx-translate/core';
import { formatNumber, DatePipe, formatDate } from '@angular/common';
import { ButtonModel } from '../models/button-model';
import { GridQueryModel } from '../mi-grid-v2/model/grid-query-model';
import { GridSearchModel } from '../mi-grid-v2/model/grid-search-model';

@Injectable()
export class CommonBindingDataService {
  deleteButton: ButtonModel;
  editButton: ButtonModel;
  statusButton: ButtonModel;
  detailsButton: ButtonModel;
  fareButton: ButtonModel;
  assignButton: ButtonModel;
  detailReportButton: ButtonModel;
  feedbackButton: ButtonModel;
  assignDriverButton: ButtonModel;
  viewCompletedToursButton: ButtonModel;
  chatButton: ButtonModel;
  saveButton: ButtonModel;
  refundButton: ButtonModel;
  cancelButton: ButtonModel;
  startButton: ButtonModel;
  endButton: ButtonModel;
  notifyButton: ButtonModel;
  sendButton: ButtonModel;
  searchUrl: string;
  replyButton: ButtonModel;
  title = new BehaviorSubject('');
  public redrawSidebar: Subject<any> = new Subject<any>();
  queryUpdateObject: GridQueryModel = {
    'offset': 0,
    'sortField': '',
    'sortOrderString': 'asc',
    'sortOrder': 1
  };

  queryDefaultObject: GridQueryModel = {
    'offset': 0,
    'sortField': '',
    'sortOrderString': 'asc',
    'sortOrder': 1
  }

  searchUpdateObject: GridSearchModel = {
    'searchText': ''
  };

  searchDefaultObject: GridSearchModel = {
    'searchText': ''
  }


  constructor(private restApiService: RestApiService,
    private storageService: StorageService,
    private translateService: TranslateService,
    private datePipe: DatePipe,
  ) {
    this.initializeButtons();
  }

  getServiceType(): Observable<any> {
    if (this.storageService.getItem(AppSettings.SERVICE_TYPE) !== null) {
      return of(this.storageService.getItem(AppSettings.SERVICE_TYPE));
    } else {
      return this.restApiService.get('/secure/service-types?clientType=WEB');
    }
  }

  toGMT(now) {
    return new Date(now.getTime() - (now.getTimezoneOffset() * 60000)).getTime();
  }

  toLocalTime(milliseconds) {
    const now = new Date(milliseconds);
    return new Date(milliseconds + now.getTimezoneOffset() * 60000).getTime();
  }

  toLocalDate(milliseconds) {
    const now = new Date(milliseconds);
    return new Date(milliseconds + now.getTimezoneOffset() * 60000);
  }

  unitConversionMToKm(m) {
    const results = m / 1000;
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  unitConversionKMToM(km) {
    const results = km * 1000;
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  unitConversionMinToMilliseconds(min) {
    const results = ((min * 60) * 1000);
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  getBookLaterMinTime(serviceType, subCode) {
    const extraTime = this.getSpecificTimeout(serviceType, subCode);
    return new Date((new Date).getTime() + extraTime);
  }

  unitConversionMillisecondsToMin(milliseconds) {
    const results = ((milliseconds / 60) / 1000);
    if (results > 0) {
      return results;
    } else {
      return 0;
    }
  }

  addLapseTimeInEndDate(endDate) {
    return endDate + AppSettings.twentyThreeFiftyNineLapse;
  }

  centerLatLng(dropPoints) {
    if (dropPoints.length === 0) {
      return 0;
    }
    const latArray = [];
    const lngArray = [];
    for (const points of dropPoints) {
      latArray.push(points.lat);
      lngArray.push(points.lng);
    }
    return this.findCenterDashLatLng(lngArray, latArray);
  }

  findCenterDashLatLng(lngArray, latArray) {
    const x1 = this.findMinMaxValue('min', lngArray);
    const x2 = this.findMinMaxValue('max', lngArray);
    const y1 = this.findMinMaxValue('min', latArray);
    const y2 = this.findMinMaxValue('max', latArray);
    const centerPoly = {
      lat: y1 + ((y2 - y1) / 2),
      lng: x1 + ((x2 - x1) / 2)
    };
    return centerPoly;
  }

  findMinMaxValue(type, data) {
    if (type === 'max') {
      return Math.max.apply(null, data);
    } else {
      return Math.min.apply(null, data);
    }
  }

  getServiceTypeKey(id) {
    let serviceType, serviceTypeId;
    if (this.storageService.getItem(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItem(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.id === id) {
          serviceTypeId = element.serviceType;
        }
      });
    }
    return serviceTypeId;
  }


  getServiceTypeCodeBy(id) {
    let serviceType, code;
    if (this.storageService.getItem(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItem(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.id === id) {
          code = element.code;
        }
      });
    }
    return code;
  }

  getServiceTypeByCode(code) {
    let serviceType;
    const serviceTypeByCode = [];
    if (this.storageService.getItem(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItem(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.code === code) {
          serviceTypeByCode.push(element);
        }
      });
    }
    return serviceTypeByCode;
  }

  getServiceTypeId(key) {
    let serviceType, serviceTypeId;
    if (this.storageService.getItem(AppSettings.SERVICE_TYPE) !== null) {
      serviceType = this.storageService.getItem(AppSettings.SERVICE_TYPE);
      serviceType.forEach(element => {
        if (element.serviceType === key) {
          serviceTypeId = element.id;
        }
      });
    }
    return serviceTypeId;
  }

  searchAutocomplete(url: string): Observable<any> {
    return this.restApiService.get(url);
  }

  getSeatLayout(url: string): Observable<any> {
    return this.restApiService.get(url);
  }

  removeGivenServiceTypeFromList(key, serviceTypeList?) {
    let serviceTypes;
    if (serviceTypeList) {
      serviceTypes = serviceTypeList;
    } else {
      serviceTypes = this.storageService.getItem(AppSettings.SERVICE_TYPE);
    }
    serviceTypes.forEach((item, index) => {
      if (key === item.subCode) {
        serviceTypes.splice(index, 1);
      }
    });
    return serviceTypes;
  }

  getSpecificTimeout(code, subCode) {
    const timeouts = this.storageService.getItem(AppSettings.TIME_SETTINGS);
    if (timeouts !== null) {
      for (const item of timeouts[code]) {
        if (item.key === subCode) {
          return parseInt(item.value, 10);
        }
      }
    }
  }

  getServiceTypeOnLogin(): Observable<any> {
    return this.restApiService.get('/secure/service-types?clientType=WEB', 'page-center');
  }

  getDocumentType(): Observable<any> {
    return this.restApiService.get('/secure/driver-document-types', 'page-center');
  }
  getVehicleType(): Observable<any> {
    return this.restApiService.get('/secure/vehicle-types', 'page-center');
  }
  getVehicleDocumentType(): Observable<any> {
    return this.restApiService.get('/secure/vehicle-document-types', 'page-center');
  }

  getCountries(): Observable<any> {
    return this.restApiService.get('/secure/countries', 'page-center');
  }

  getState(id): Observable<any> {
    return this.restApiService.get(`/secure/countries/${id}/states`, 'page-center');
  }
  getCityByCountries(code): Observable<any> {
    return this.restApiService.get('/secure/countries/' + code + '/citiesbycountry', 'page-center');
  }

  getBusLayout(layoutId): Observable<any> {
    return this.restApiService.get(`/secure/bus-floor-layouts/${layoutId}`, 'page-center');
  }

  getBusLayoutADA(layoutId, adaSeats): Observable<any> {
    return this.restApiService.get(`/secure/bus-floor-layouts/${layoutId}?adaSeats=${adaSeats}`, 'page-center');
  }

  getCityByState(code): Observable<any> {
    return this.restApiService.get('/secure/countries/' + code + '/citiesbystate', 'page-center');
  }

  getDispatcher(data, code): Observable<any> {
    return this.restApiService.get(`/secure/dispatchers/data/search?searchText=${data}&roleCode=${code}`, 'page-center');
  }

  commentReply(data, id): Observable<any> {
    return this.restApiService.post(`/secure/booking/trip/${id}/comment-reply`, data, 'page-center');
  }

  getBusOperator(): Observable<any> {
    return this.restApiService.get('/secure/bus-operators', 'page-center');
  }


  getLayoutType(): Observable<any> {
    return this.restApiService.get('/secure/bus-floor-layouts', 'page-center');
  }

  searchPassengers(url: string): Observable<any> {
    return this.restApiService.get(url, 'page-center');
  }

  readNotifications(notificationId, readStatus): Observable<any> {
    return this.restApiService.put(`/secure/notification/${notificationId}/status`, readStatus, 'page-center');
  }

  addCorporateBooking(data, serviceType): Observable<any> {
    return this.restApiService.post(`/secure/booking/${serviceType}/corporate`, data, 'page-center');
  }

  addHotelBooking(data, serviceType, hotelId): Observable<any> {
    return this.restApiService.post(`/secure/hotels/${hotelId}/booking/${serviceType}`, data, 'page-center');
  }

  getLabel(string) {
    let select;
    this.translateService.get(string).subscribe(translatedValue => {
      select = translatedValue;
    });
    return select;
  }

  getTiming() {
    return this.restApiService.get('/secure/settings/timeouts', 'page-center');
  }

  packageBind(serviceType, passengerId?, vehicleTypeId?): Observable<any> {
    if (vehicleTypeId !== null && vehicleTypeId !== undefined) {
      const url = '/secure/packages/allpackages/'
        + this.storageService.getItem(AppSettings.SERVICE_AREA_ID) + '/' +
        serviceType + '?vehicleTypeId=' + vehicleTypeId + '&passengerId=' + passengerId;
      return this.restApiService.get(url);
    } else {
      const url = '/secure/packages/allpackages/'
        + this.storageService.getItem(AppSettings.SERVICE_AREA_ID) + '/' + serviceType;
      return this.restApiService.get(url);
    }
  }

  getPricingDetails(data) {
    return this.restApiService.get('/secure/packages/' + data, 'page-center');
  }


  setPackages(data, id?, corporateId?): Observable<any> {
    return this.restApiService.put(`/secure/packages/${id}/partners/${corporateId}`, data, 'page-center');
  }

  getRentalPricingDetails(params) {
    return this.restApiService.get('/secure/packages/rental/partners/' + params, 'page-center');
  }

  updateRentalPackage(data, corporateId) {
    return this.restApiService.post(`/secure/packages/rental/partners/${corporateId}`, data, 'page-center');
  }

  addPricingPackages(data, id?: null) {
    if (id !== undefined && id !== null && id !== '') {
      return this.restApiService.put('/secure/packages/' + id + '/chauffeur', data, 'page-center');
    } else {
      return this.restApiService.post('/secure/packages', data, 'page-center');
    }
  }

  updateCorporatePricingPackages(data, id: null, corporateId) {
    return this.restApiService.put('/secure/packages/' + id + '/partners/' + corporateId, data, 'page-center');

  }

  setRoute(data, corporateId?): Observable<any> {
    return this.restApiService.put(`/secure/packages/routes/destinations/rates/partners/${corporateId}`, data, 'page-center');
  }


  getRoutingDetails(routeId, partnerId) {
    return this.restApiService.get(`/secure/packages/routes/${routeId}/partners/${partnerId}`, 'page-center');
  }

  searchDriver(url: string): Observable<any> {
    return this.restApiService.get(url);
  }

  addUpdateBooking(data, serviceType, id?): Observable<any> {
    return this.restApiService.post(`/secure/booking/${serviceType}/taxi`, data, 'page-center');
  }

  getHotels(): Observable<any> {
    return this.restApiService.get(`/secure/hotels`, 'page-center');
  }

  assignDriver(bookingId, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + bookingId + '/assign-driver', data);
  }

  resendCode(bookingId, passengerId): Observable<any> {
    return this.restApiService.put('/secure/booking/' + bookingId + '/verification-code');
  }

  cancelBooking(id, data): Observable<any> {
    return this.restApiService.put('/secure/booking/' + id + '/cancel', data);
  }

  bookingDetails(id): Observable<any> {
    return this.restApiService.get('/secure/booking/' + id);
  }

  getAmenities(): Observable<any> {
    return this.restApiService.get('/secure/amenities', 'page-center');
  }

  getBusType(): Observable<any> {
    return this.restApiService.get('/secure/bus-types', 'page-center');
  }

  getBusDestinationPoints(): Observable<any> {
    return this.restApiService.get('/secure/bus-destinations', 'page-center');
  }
  startTrip(data, tripId): Observable<any> {
    return this.restApiService.put('/secure/booking/trip/' + tripId + '/start-trip', data);
  }

  securityCheck(data, tripId): Observable<any> {
    return this.restApiService.post('/secure/bookings/' + tripId + '/security-check', data);
  }

  endTrip(data, tripId): Observable<any> {
    return this.restApiService.put('/secure/booking/trip/' + tripId + '/end-trip', data);
  }

  rentalEndTrip(data, tripId): Observable<any> {
    return this.restApiService.put('/secure/bookings/' + tripId + '/end-rental-booking', data);
  }

  extendPackage(tripId): Observable<any> {
    return this.restApiService.put('/secure/bookings/' + tripId + '/extend-package');
  }

  getDriverCurrentLocation(driverId): Observable<any> {
    return this.restApiService.get('/secure/drivers/' + driverId + '/location', 'page-center');
  }

  convertMillisecondToDateForListView(params) {
    let date = '';
    if (params.value > 0) {
      date = new Date(params.value).toLocaleDateString();
    }
    return date;
  }

  initializeButtons() {
    this.statusButton = {
      field: 'STATUS',
      class: 'STATUS',
      ariaLabel: (data) => {
        return data.activated ? this.getLabel('aria_label_deactivate_button') :
          this.getLabel('aria_label_activate_button')
      },
      title: (data) => {
        if (data.activated) {
          return {
            title: this.getLabel('label_deactivate'),
            icon: 'fa fa-check-circle',
            btnClass: 'btn-delete',
          };
        }
        return {
          title: this.getLabel('label_active'),
          icon: 'fa fa-check-circle',
          btnClass: 'btn-edit',
        };
      },
      show: (data) => {
        if (data.activated) {
          return `<span title=${this.getLabel('label_deactivate')}
          class="fa fa-check-circle fa-lg status btn-edit"></span>`;
        } else {
          return `<span title=${this.getLabel('label_active')}
          class="fa fa-check-circle fa-lg status activate btn-delete"></span>`;
        }
      }
    };

    this.refundButton = {
      field: 'REFUND',
      class: 'REFUND',
      ariaLabel: (data) => {
        return (!data.refunded && data.payableAmount !== 0) ? this.getLabel('aria_label_deactivate_button') :
          ''
      },
      show: (data) => {
        if (!data.refunded && data.payableAmount !== 0) {
          return `<span title=${this.getLabel('label_refund')} class="fa fa-credit-card fa-lg btn-delete"></span>`;
        }
      },
      title: (data) => {
        if (!data.refunded && data.payableAmount !== 0) {
          return {
            title: this.getLabel('label_delete'),
            icon: 'fa fa-credit-card',
          };
        }
      },
    };

    this.chatButton = {
      field: 'CHAT',
      class: 'CHAT',
      ariaLabel: () => {
        return this.getLabel('aria_label_chat_button');
      },
      show: () => {
        return `<span title=${this.getLabel('label_chat')} class="fa fa-comments-o fa-lg btn-edit"></span>`;
      },
      title: () => {
        return {
          title: this.getLabel('label_chat'),
          icon: 'fa fa-comments-o',
        };
      },
    };

    this.editButton = {
      field: 'EDIT',
      ariaLabel: () => {
        return this.getLabel('aria_label_edit_button');
      },
      class: 'EDIT', show: (data) => {
        return `<span title=${this.getLabel('label_edit')} class="fa fa-pencil btn-edit"></span>`;
      },
      title: () => {
        return {
          title: this.getLabel('label_edit'),
          icon: 'fa fa-pencil',
        };
      },
    };

    this.sendButton = {
      field: 'SEND',
      class: 'SEND',
      ariaLabel: () => {
        return this.getLabel('aria_label_send_button');
      },
      show: (data) => {
        return `<span title=${this.getLabel('label_send')} class="fa fa-paper-plane btn-edit"></span>`;
      },
      title: () => {
        return {
          title: this.getLabel('label_send'),
          icon: 'fa fa-paper-plane',
        };
      },
    };

    this.deleteButton = {
      field: 'DELETE',
      ariaLabel: () => {
        return this.getLabel('aria_label_delete_button');
      },
      class: 'DELETE',
      show: (data) => {
        return `<span title=${this.getLabel('label_delete')} class="fa fa-trash btn-delete"></span>`;
      },
      title: () => {
        return {
          title: this.getLabel('label_delete'),
          icon: 'fa fa-trash',
        };
      },
    };

    this.detailsButton = {
      field: 'DETAILS',
      class: 'DETAILS',
      ariaLabel: () => {
        return this.getLabel('aria_label_details_button');
      },
      title: () => {
        return {
          title: this.getLabel('label_view_details'),
          icon: 'fa fa-eye',
        };
      },
      show: () => {
        return `<span title="${this.getLabel('label_view_details')}" class="fa fa-eye btn-edit"></span>`;
      }
    };

    this.fareButton = {
      field: 'FARE',
      class: 'FARE',
      ariaLabel: () => {
        return this.getLabel('aria_label_fare_button');
      },
      title: () => {
        return {
          title: this.getLabel('label_view_fare'),
          icon: 'fa fa-usd',
        };
      },
      show: () => {
        return `<span title="${this.getLabel('label_view_fare')}" class="fa fa-usd btn-edit"></span>`;
      }
    };

    this.assignButton = {
      field: 'ASSIGN',
      class: 'ASSIGN',
      ariaLabel: (data) => {
        if (data.activated) {
          return this.getLabel('aria_label_assign_button');
        } else {
          return null;
        }
      },
      title: (data) => {
        if (data.activated) {
          return {
            title: this.getLabel('label_assign'),
            icon: 'fa fa-user-circle-o',
          };
        } else {
          return null;
        }
      },
      show: (data) => {
        if (data.activated) {
          return `<span title=${this.getLabel('label_assign')} class="fa fa-user-circle-o fa-lg"></span>`;
        } else {
          return null;
        }
      }
    };

    this.detailReportButton = {
      field: 'REPORT_DETAILS',
      class: 'REPORT_DETAILS',
      ariaLabel: () => {
        return this.getLabel('aria_label_details_button');
      },
      title: () => {
        return {
          title: this.getLabel('label_details'),
          icon: 'fa fa-eye',
        };
      },
      show: () => {
        return `<span title=${this.getLabel('label_details')} class="fa fa-hand-pointer-o fa-lg status deactivate"></span>`;
      }
    };

    this.feedbackButton = {
      field: 'FEEDBACK',
      class: 'FEEDBACK',
      ariaLabel: () => {
        return this.getLabel('aria_label_feedback_button');
      },
      title: () => {
        return {
          title: this.getLabel('label_report_feedback'),
          icon: 'fa fa-comments-o',
        };
      },
      show: () => {
        return `<span title=${this.getLabel('label_report_feedback')} class="fa fa-comments-o fa-lg status activate"></span>`;
      }
    };

    this.assignDriverButton = {
      field: 'ASSIGN-DRIVER',
      class: 'ASSIGN-DRIVER',
      ariaLabel: () => {
        return this.getLabel('aria_label_assign_driver_button');
      },
      title: () => {
        return {
          title: this.getLabel('label_manage_tour'),
          icon: 'fa fa-bus',
        };
      },
      show: () => {
        return `<span title="${this.getLabel('label_manage_tour')}" class="fa fa-bus fa-lg btn-edit"></span>`;
      }
    };

    this.viewCompletedToursButton = {
      field: 'VIEW-COMPLETED-TOURS',
      class: 'VIEW-COMPLETED-TOURS',
      ariaLabel: () => {
        return this.getLabel('aria_label_view_button');
      },
      title: () => {
        return {
          title: this.getLabel('label_completed_tours'),
          icon: 'fa fa-eye',
        };
      },
      show: () => {
        return `<span title="${this.getLabel('label_completed_tours')}" class="fa fa-eye fa-lg btn-edit"></span>`;
      }
    };

    this.notifyButton = {
      field: 'NOTIFY',
      class: 'NOTIFY',
      ariaLabel: () => {
        return this.getLabel('aria_label_notify_button');
      },
      title: () => {
        return {
          title: this.getLabel('access_notification_send'),
          icon: 'fa fa-envelope',
        };
      },
      show: () => {
        return `<span title="${this.getLabel('access_notification_send')}" class="fa fa-envelope fa-lg btn-edit"></span>`;
      }
    };

    this.saveButton = {
      field: 'SAVE',
      class: 'SAVE',
      ariaLabel: (data) => {
        if (data.status === 'New') {
          return this.getLabel('aria_label_save_button');
        }
      },
      title: (data) => {
        if (data.status === 'New') {
          return {
            title: this.getLabel('label_save'),
            icon: 'fa fa-floppy-o',
          };
        }
      },
      show: (data) => {
        if (data.status === 'New') {
          return `<span title="${this.getLabel('label_save')}" class="fa fa-floppy-o fa-lg btn-edit"></span>`;
        }
      }
    }

    this.startButton = {
      field: 'START_TOUR',
      class: 'START_TOUR',
      ariaLabel: (data) => {
        if (data.status === 'New') {
          return this.getLabel('aria_label_start_button');
        }
      },
      title: (data) => {
        if (data.status === 'New') {
          return {
            title: this.getLabel('label_start_trip'),
            icon: 'fa fa-play',
          };
        } else {
          return null;
        }
      },
      show: (data) => {
        if (data.status === 'New') {
          return `<span title="${this.getLabel('label_start_trip')}" class="fa fa-play fa-lg btn-edit"></span>`;
        } else {
          return null;
        }
      }
    }

    this.endButton = {
      field: 'END_TOUR',
      class: 'END_TOUR',
      ariaLabel: (data) => {
        if (data.status === 'Started') {
          return this.getLabel('aria_label_end_button');
        }
      },
      title: (data) => {
        if (data.status === 'Started') {
          return {
            title: this.getLabel('label_end_trip'),
            icon: 'fa fa-stop-circle',
          };
        }
      },
      show: (data) => {
        if (data.status === 'Started') {
          return `<span title="${this.getLabel('label_end_trip')}" class="fa fa-stop-circle fa-lg btn-delete"></span>`;
        }
      }
    }

    this.cancelButton = {
      field: 'CANCEL_TOUR',
      class: 'CANCEL_TOUR',
      ariaLabel: (data) => {
        if (data.status === 'New') {
          return this.getLabel('aria_label_cancel_button');
        }
      },
      title: (data) => {
        if (data.status === 'New') {
          return {
            title: this.getLabel('label_cancel_tour'),
            icon: 'fa fa-ban',
          };
        } else {
          return null;
        }
      },
      show: (data) => {
        if (data.status === 'New') {
          return `<span title="${this.getLabel('label_cancel_tour')}" class="fa fa-ban fa-lg btn-delete"></span>`;
        } else {
          return null;
        }
      }
    }

    this.replyButton = {
      field: 'REPLY',
      class: 'REPLY',
      ariaLabel: (data) => {
        if (data.status === 'PENDING') {
          return this.getLabel('aria_label_reply_button');
        }
      },
      title: (data) => {
        if (data.status === 'PENDING') {
          return {
            title: this.getLabel('aria_label_reply_button'),
            icon: 'fa fa-envelope',
          };
        } else {
          return null;
        }
      },
      show: (data) => {
        if (data.status === 'PENDING') {
          return `<span title="${this.getLabel('aria_label_reply_button')}" class="fa fa-envelope fa-lg btn-edit"></span>`;
        } else {
          return null;
        }
      },
    };
  }

  mapToDropDownData(list, key = 'name', keyValue = 'id') {
    return list.map((data) => ({ label: data[key], value: data[keyValue] }));
  }

  setTitle(title: string) {
    this.title.next(title);
  }

  hasAccessPresent(accessCode) {
    const menuList = this.getSelectedMenuAccessesList();
    const validateMenuList = menuList === null ? [] : menuList;
    const hasAccess = validateMenuList.find((elm) => {
      return elm.accessCode === accessCode;
    });

    if (hasAccess !== undefined && hasAccess !== null) {
      return true;
    }
    return false;
  }

  getSelectedMenuAccessesList(returnObj?) {
    // const menuName = this.storageService.getItem('selectedMenu');
    const location = window.location.href;
    const urlArray = location.split('#');
    const displayUrls = urlArray[urlArray.length - 1];
    const displayUrl = displayUrls.split('?')[0];
    let menuItems: any = [];
    menuItems = this.storageService.getItem(AppSettings.ACCESS_MENU);
    for (let menuIndex = 0; menuIndex < menuItems.length; menuIndex++) {
      const menu = menuItems[menuIndex];
      if (menu.displayUrl === '' && menu.subMenuList && menu.subMenuList.length) {
        const subMenuAccess = this.checkSubMenus(menu.subMenuList, displayUrl, returnObj);
        if (subMenuAccess !== undefined && subMenuAccess !== null) {
          return subMenuAccess;
        }
      } else {
        if (displayUrl.indexOf(menu.displayUrl) >= 0) {
          // if (menu.accessGroupCode === menuName) {
          if (returnObj) {
            return menu;
          }
          return menu.accesses;
        } else {
          if (menu.subMenuList && menu.subMenuList.length) {
            const subMenuAccess = this.checkSubMenus(menu.subMenuList, displayUrl, returnObj);
            if (subMenuAccess !== undefined && subMenuAccess !== null) {
              return subMenuAccess;
            }
          }
        }
      }
    }
    return [];
  }
  checkSubMenus(subMenuList, menuName, returnObj?) {
    if (subMenuList !== undefined && subMenuList !== null) {
      for (let menuIndex = 0; menuIndex < subMenuList.length; menuIndex++) {
        const menu = subMenuList[menuIndex];
        if (menuName.indexOf(menu.displayUrl) >= 0) {
          // if (menu.accessGroupCode === menuName) {
          if (returnObj) {
            return menu;
          }
          return menu.accesses;
        } else {
          if (menu.subMenuList && menu.subMenuList.length) {
            const subMenuAccess = this.checkSubMenus(menu.subMenuList, menuName, returnObj);
            if (subMenuAccess !== undefined && subMenuAccess !== null) {
              return subMenuAccess;
            }
          }
        }
      }
      return null;
    }
  }

  getDropDownData(list, key, value) {
    return (list !== null && list !== undefined) ?
      list.map(item => ({ label: item[key], value: item[value] })) : [];
  }

  getDateFormat() {
    let dateFormatRecord = this.getTenantConfigValue(AppSettings.DATE_FORMAT).toLowerCase();
    const check = dateFormatRecord.includes('yyyy');
    if (check) {
      dateFormatRecord = dateFormatRecord.replace('yyyy', 'yy');
    }
    return dateFormatRecord;
  }

  getTenantConfigValue(configKey) {
    let tenantConfig: any;
    const tenantConfigs = this.storageService.getItem(AppSettings.TENANT_CONFIG)
    tenantConfig = tenantConfigs === null ? [] : tenantConfigs;
    for (let index = 0; index < tenantConfig.length; index++) {
      if (tenantConfig[index].configKey === configKey) {
        return tenantConfig[index].configValue;
      }
    }
    return '';
  }

  getCities(): Observable<any> {
    return this.restApiService.get('/secure/service-area/cities');
  }

  getUTCDateWithOutLocalTime(time) {
    const tz = moment().utcOffset();
    time = time - (tz * 60000);
    return moment(time).format('ll');
  }

  getFilters(filterUrl: any) {
    const filterObject = {};
    const filterData = filterUrl.split('?')[1] === undefined ? [] : filterUrl.split('?')[1].split('&');
    filterData.forEach(element => {
      const data = element.split('=');
      filterObject[data[0]] = data[1]
    });
    return filterObject;
  }

  formatCurrency(amount) {
    return formatNumber(amount, AppSettings.DATE_FORMAT_LOCALE, '1.2-2');
  }

  getIcon(totalSeatBooked: any, totalAdaSeatBooked: any) {
    const eDiv = document.createElement('div');
    if (Number(totalAdaSeatBooked) === 0) {
      eDiv.innerHTML = `<span>${totalSeatBooked}</span>`;
    } else {
      eDiv.innerHTML = `<div class="flex"><span class="mt6">${totalSeatBooked}</span>
   <img class="ada-seats" alt="ada" src="assets/images/empty-ada-seat.svg" /></div>`;
    }
    return eDiv;
  }

  getTime(seconds) {
    const time = new Date(1970, 0, 1);
    time.setSeconds(seconds);
    return formatDate(time, AppSettings.DEFAULT_TIME_FORMAT, AppSettings.DATE_FORMAT_LOCALE);
  }

  convertEpochToDate(date) {
    return this.datePipe.transform(date, AppSettings.DEFAULT_DATE_FORMAT);
  }

  getName(firstName, lastName) {
    let fullName = '';
    if (firstName !== null && lastName !== null) {
      fullName = firstName + ' ' + lastName;
    } else if (firstName !== null) {
      fullName = firstName;
    } else if (lastName !== null) {
      fullName = lastName;
    }
    return fullName;
  }

  getPhoneNumberWithCode(numCountryCode, phoneNum) {
    if (numCountryCode !== undefined && numCountryCode !== '') {
      return numCountryCode + ' ' + phoneNum;
    } else {
      return phoneNum;
    }
  }
}
